define('controllers/archive/overview',[
	'jquery',
	'modules/page',
	'isotope',
	'widgets/filters',
], function ($, page, Isotope) {

	var overview = {

		id: 'archive-overview',

		ready: false,
		enabled: null,

		filter: null,
		sort: 'date',

		scrollTop: 0,

		setup: function () {

			if (this.ready) return this;

			this.update();

			this.ready = true;
			return this;

		},

		enable: function () {

			if (this.enabled) return this;

			$.subscribe({
				'filterSelect.overview': $.proxy(this, 'onFilterSelect'),
				'sortSelect.overview': $.proxy(this, 'onSortSelect')
			});

			this.$el.addClass('enabled');

			page.$win.scrollTop(this.scrollTop);

			this.enabled = true;

			if (this.isotope)
				this.isotope.layout();

			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.overview');
			$.unsubscribe('.overview');

			this.$el.removeClass('enabled');

			this.scrollTop = page.$win.scrollTop();

			this.enabled = false;

			return this;

		},

		update: function () {

			var $el = $('#' + this.id);

			if (this.$el && $el[0] == this.$el[0])
				return;

			this.$el = $el;
			this.$list = this.$el.find('.list');
			this.$items = this.$el.find('.item');

			if (this.isotope)
				this.isotope.destroy();

			this.isotope = new Isotope(this.$list[0], {
				layoutMode: 'masonry',
				itemSelector: '.item',
				hiddenStyle: { opacity: 0 },
				vissibleStyle: { opacity: 1 },
				getSortData: {
					id: '[data-id] parseInt',
					submitted: '[data-submitted] parseInt',
					written: '[data-written] parseInt'
				},
				isInitLayout: false,
			});

			this.isotope.on('layoutComplete', $.proxy(function () {
				this.$el.addClass('layout');
			}, this));
			this.isotope.arrange();

		},

		onFilterSelect: function (e, id) {

			this.setFilter(id);

		},

		setFilter: function (filter) {

			var pattern = '*';

			if (this.filter == filter) return;

			if ($.isNumeric(filter))
				pattern = '[data-tags*="|' + filter + '|"]';
			else if (filter)
				pattern = '.' + filter;

			this.isotope.arrange({
				filter: pattern
			});

			this.filter = filter;
			$.publish('filterSet', filter);

			return this;

		},

		onSortSelect: function (e, sort) {

			this.setSort(sort);

		},

		setSort: function (sort) {

			this.sort = sort;

			this.isotope.arrange({
				sortBy: [sort, 'id']
			});

			console.log('sort', sort);
			$.publish('sortSet', sort);

			return this;

		}

	};


	// --- isotope customization

	var _reveal = Isotope.Item.prototype.reveal;
	Isotope.Item.prototype.reveal = function() {
		_reveal.apply(this, arguments);
		$(this.element).removeClass('hidden');
	};

	var _hide = Isotope.Item.prototype.hide;
	Isotope.Item.prototype.hide = function() {
		_hide.apply(this, arguments);
		$(this.element).addClass('hidden');
	};

	// ---

	return overview;

});
